import React from 'react';
import './styles.scss';

interface StepCircleProps {
    n: number;
}

const StepCircle = ({ n }: StepCircleProps) => (
    <div className="rb-step-circle">{n}</div>
);

export default StepCircle;
